import PropTypes from 'prop-types';
import IconChevronUpWhite from "assets/images/icons/chevron-up-white.svg";
import { useState } from "react";
import "components/ui/Expandable/Expandable.scss";
import { useCollapse } from "react-collapsed";

const Expandable = ({ label, expanded = false, hideHeader = false, children }) => {
  const [isExpanded, setExpanded] = useState(expanded)
  const { getCollapseProps, getToggleProps } = useCollapse({ isExpanded })

  return (
    <div className={ `expandable ${ isExpanded ? 'expandable--expanded' : '' }` }>
      {
        !hideHeader &&
        <div
          className={ `expandable__header ${ isExpanded ? 'expandable__header--expanded' : '' }` } { ...getToggleProps({
          onClick: () => setExpanded(!isExpanded),
        }) }>
          { label }
          <img src={ IconChevronUpWhite } className={ !isExpanded ? 'rotate180' : '' } alt="Toon of verberg opties"/>
        </div>
      }
      <div { ...getCollapseProps() }>
        { children }
      </div>
    </div>
  );
}

Expandable.propTypes = {
  label: PropTypes.string.isRequired,
  expanded: PropTypes.bool,
}

export default Expandable;
